import { JSX } from "preact";
import type { ChoicePrompt } from "../transport";

interface Props {
  prompt: ChoicePrompt;
  onSelect: (choice: string) => void;
  disabled?: boolean;
}

export function ChoiceChips({ prompt, onSelect, disabled = false }: Props): JSX.Element {
  return (
    <div class="acc-chips" role="group" aria-label={prompt.prompt}>
      {prompt.choices.map((choice) => (
        <button
          type="button"
          key={choice}
          class="acc-chip"
          disabled={disabled}
          onClick={() => onSelect(choice)}
        >
          {choice}
        </button>
      ))}
      {prompt.allow_free_text && (
        <span class="acc-chip-hint">— or type your own</span>
      )}
    </div>
  );
}
